import { PaginationResponse } from '@repo/ui/data-table'

import { Friend } from '../../lib/types/models/friend/friend'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentFriends(enrollmentId: number): Promise<PaginationResponse<Friend>> {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getFriends.url, {
        id: enrollmentId
      })
    )
    .get<PaginationResponse<Friend>>()
}
